export const showPageNumbers = (page, currentPage, totalPages) => {
  return (
    (page === 0 && currentPage < 5) ||
    (page === totalPages - 1 && currentPage > totalPages - 5) ||
    (page > currentPage - 3 && page < currentPage + 2)
  );
};

export const replaceColumnIdsWithLabels = (text, columns) => {
  if (typeof text !== "string" || !Array.isArray(columns)) return text;

  return text.replace(/\{([^{}]+)\}/g, (_match, id) => {
    const column = columns.find(
      (col) => String(col._id || col.id) === String(id)
    );

    return column?.label ?? id;
  });
};
